import React from 'react';
import { Label } from './label';
import {
  Select,
  SelectItem,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from './select';

export type EnumFilter = {
  type: 'enum';
  key: string;
  label: string;
  value?: string;
  options: string[];
  isMainFilter?: boolean;
};

type EnumFilterComponentProps = {
  filter: EnumFilter;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
};

export const EnumFilterComponent = ({
  filter,
  value,
  onChange,
}: EnumFilterComponentProps): React.JSX.Element => {
  return (
    <div className="flex items-center gap-2">
      <Label htmlFor={filter.key} className="text-gray-500">
        {filter.label}
      </Label>
      <Select
        value={value}
        onValueChange={(val: string | number | boolean | undefined): void => {
          onChange(val === 'any' ? undefined : (val as string));
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder={filter.label} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="any">Any</SelectItem>
          {filter.options.map((option: string) => {
            return (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
};
